import { memo } from 'react';
import styled from 'styled-components';

const StyledBadge = styled.div<StyledBadgeProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${({ $backgroundColor }) => $backgroundColor};
    color: ${({ $textColor }) => $textColor};
    border-radius: 1.2rem;
    min-width: 1.4rem;
    min-height: 1.4rem;
    padding: 0.2rem;
    text-align: center;
    font-size: 1.2rem;
    line-height: 1;
`;

type StyledBadgeProps = {
    $backgroundColor: string;
    $textColor: string;
};

export type BadgeProps = Readonly<{
    count: number;
    textColor: string;
    backgroundColor: string;
    className?: string;
}>;

export type BadgeConfig = Readonly<{
    count: number;
    textColor: string;
    backgroundColor: string;
}>;

function BadgeBase({ backgroundColor, textColor, count, className }: BadgeProps) {
    return (
        <StyledBadge
            className={className}
            $backgroundColor={backgroundColor}
            $textColor={textColor}
        >
            <div>{count}</div>
        </StyledBadge>
    );
}

export const Badge = memo(BadgeBase);
